import { render } from "./EmpDashboardHeader.vue?vue&type=template&id=06ac289e"
import script from "./EmpDashboardHeader.vue?vue&type=script&lang=js"
export * from "./EmpDashboardHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__